module.exports = __webpack_public_path__ + "static/media/guide_3.999ad5f0.svg";